import { CSSProperties } from 'react';

export const Debug = ({
  children,
  data = undefined,
  style = undefined,
}: {
  children?: JSX.Element;
  data?: any;
  style?: CSSProperties;
}) => {
  const debugMode = localStorage.getItem('debugUI');

  return debugMode ? (
    <div
      className={'flex p-1 text-xxs font-normal text-left bg-purple-light-2'}
      style={style}
    >
      {children && children}
      <pre>{data && JSON.stringify(data, null, 2)}</pre>
    </div>
  ) : (
    <></>
  );
};
